module.exports = __webpack_public_path__ + "static/media/lkw-fahrverbot.25f7c846.svg";